import { NgModule } from '@angular/core';
import { InvoicesService } from './invoices/invoices.service';
import { CardsService } from './cards/cards.service';
import { LimitsService } from './limits/limits.service';
import { AgreementService } from './agreement/agreement.service';
import { UserService } from './user/user.service';
import { FleetGroupsService } from './fleet-groups/fleet-groups.service';
import { StatsService } from './stats/stats.service';
import { CoreModule } from '../core/core.module';
import { TransactionsService } from './transactions/transactions.service';

@NgModule({
  imports:      [ CoreModule ],
  providers:    [ UserService,
                  InvoicesService,
                  CardsService,
                  LimitsService,
                  FleetGroupsService,
                  StatsService,
                  TransactionsService,
                  AgreementService ],
  declarations: []
})
export class ResourcesModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/resources/resources.module.ts